/* eslint-disable camelcase,no-console */
/**
 * react/no-string-refs 历史原因的代码，不敢删除
 */
/* eslint-disable react/no-string-refs */

import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { v4 as uuidV4 } from 'uuid';
// noinspection ES6PreferShortImport
import { sendLog, sendMessage } from '@/api/index';
import Emoj from '@/components/emoj/emoj';
import AudioGuideModal from '@/components/modal/audio-guide';
import RecordBox from '@/components/record-box';
import Toast from '@/components/toast/toast';
import Tooltip from '@/components/tool-tip';
import { CDN_BASE_URL } from '@/constants';
import { bus, CLOSE, GET_AUDIO_SENDING_STATUS, SEND_MESSAGE, START_SEND_AUDIO } from '@/event/message_events';
import { ApiUri, confirmPlatfrom, postMessageData, request } from '@/helper';
import { getToken } from '@/lib/fetch';
import app, { isTouchScreen } from '@/api/app';
import { upload } from '@/utils/oss';
import record from '@/utils/record';
import './send.scss';

const ENTER_KEYCODE = 13;

const AUDIO_TOTAL_TIME = 30;

const DEBOUNCE_TIME = 500;

const BROWSER_CAN_SEND_AUDIO = !!navigator.getUserMedia;

class Send extends React.Component {
  audioIsPrimary = isTouchScreen();

  /**
   * @type {RecordInstance | null}
   */
  record = null;

  constructor(props) {
    super(props);

    // TODO 这里之后会整合到桥里面去
    if (window.XiguaElectronBridge && window.XiguaElectronBridge.capturePage) {
      this.capturePage = window.XiguaElectronBridge.capturePage;
    }
    app.caniuse('capturePage').then((canUseCapturePage) => {
      if (canUseCapturePage) {
        this.capturePage = async () => {
          const res = await app.capturePage();
          return res.image;
        };
        this.setState({
          captureTip: '发送截图',
        });
      }
    });

    // 有且仅有浏览器没有自带的录音器的时候, 再查询桥是否支持
    if (!BROWSER_CAN_SEND_AUDIO) {
      app.caniuse('getRecorder').then((canUseRecorder) => this.setState({
        browserCanSendAudio: canUseRecorder,
      }));
    }
    // if (navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
    //   this.capturePage = async () => {
    //     const canvas = document.createElement('canvas');
    //     const context = canvas.getContext('2d');
    //     const video = document.createElement('video');
    //
    //     const captureStream = await navigator.mediaDevices.getDisplayMedia({ video: true });
    //     video.srcObject = captureStream;
    //     await new Promise((r) => setTimeout(r, 100));
    //     canvas.width = video.videoWidth;
    //     canvas.height = video.videoHeight;
    //     context.drawImage(video, 0, 0);
    //     const frame = await new Promise((r) => canvas.toBlob(r));
    //     captureStream.getTracks().forEach((track) => track.stop());
    //     return frame;
    //   };
    // }
    this.state = {
      placeholder: '请输入问题...',
      editing: false,
      selecting: false,
      recording: false,
      audioVisible: false,
      audioAuthSuccess: false,
      audioAuthFailed: false,
      audioGuideModalVisible: false,
      loudness: 0,
      hasTextMessage: false,
      browserCanSendAudio: BROWSER_CAN_SEND_AUDIO,
      captureTip: this.capturePage ? '发送截图' : '',
      // 语音中间页
      audioIntermediateVisible: this.audioIsPrimary,
    };

    // 将发送消息方法加入拓展
    this.sendTextMessage = this.sendTextMessage.bind(this);
    // eslint-disable-next-line react/prop-types
    props.fnExtends('sendTextMessage', this.sendTextMessage);

    /**
     * 延迟显示目前是否是空的音频，如果msr没有没有进行取消，则证明是空的文件
     */
    this.delayShowAudioEmptyInfo = debounce(this.showEmptyAudioMessage, DEBOUNCE_TIME);

    bus.on(GET_AUDIO_SENDING_STATUS, this.onGetAudioSendingStatus);
    bus.on(CLOSE, this.handleRecordCancelClick);

    this.captureAudioRef = React.createRef();
  }

  componentDidMount() {
    // noinspection JSDeprecatedSymbols
    this._bindEvent(this.refs.editNode);
    // eslint-disable-next-line arrow-body-style
    bus.on(SEND_MESSAGE, this.onSendMessage);
  }

  componentWillUnmount() {
    window.clearTimeout(this.timer);
    bus.off(GET_AUDIO_SENDING_STATUS, this.onGetAudioSendingStatus);
    bus.off(CLOSE, this.handleRecordCancelClick);
    bus.off(SEND_MESSAGE, this.onSendMessage);
  }

  /**
   * {@link bus.on}({@link SEND_MESSAGE}, ...)
   * @param {string[]} message
   * @return {Promise<{ online: boolean, message: any }>}
   */
  onSendMessage = async (message) => {
    try {
      const res = await sendMessage({
        ...postMessageData(this.props.data),
        ...message,
      });
      const result = {
        online: res.online,
        message: res,
      };
      this.props.$updateMessage(result);
      return result;
    } catch (e) {
      const errorMsg = this.generateErrorMsg(message);
      this.addToast('发送消息失败，请重试', 2000);
      this.props.$updateMessage(errorMsg);
      throw e;
    }
  };

  onGetAudioSendingStatus = (callback) => {
    callback(this.state.audioVisible && !this.state.audioAuthFailed);
  };

  // noinspection JSUnusedGlobalSymbols
  /**
   * 不知道是拿来干什么的，但是不敢删除
   */
  showRecord = () => {};

  // 绑定事件
  _bindEvent = (node) => {
    node.addEventListener('focus', () => {
      this.setState({
        editing: true,
      });
    });
    node.addEventListener('blur', () => {
      if (node.innerHTML === '') {
        this.setState({
          editing: false,
        });
      }
    });
  };

  /**
   * 生成一条假数据用于放入消息列表
   */
  generateErrorMsg = (message) => ({
    message: {
      avatar: window.localStorage.getItem('im#my_avatar'),
      content: message.message,
      error: true,
      msgContent: message,
      message_content_type: message.message_content_type,
      messageId: uuidV4(),
      fromMe: true,
      ...(message.message_content_type === 'audio'
        ? { fileLength: message.file_length }
        : {}),
    },
    online: false,
  });

  /**
   * 发送文件
   * @param {Blob=} blob
   * @param {any} options
   */
  sendBlob = async (blob, options = {}) => {
    const { methods, data = {}, $updateMessage, showExtraMessage, clearExtraMessage } = this.props;
    const { cb } = options;
    delete options.cb;

    const sys = data.ua;
    const platform = confirmPlatfrom();
    let fileUri;

    showExtraMessage();
    try {
      if (this.record && this.record.upload) {
        const res = await this.record.upload();
        // 上传成功后回收资源, 后面应该没有继续用到这个变量的地方了
        this.record = null;
        fileUri = res.url;
        if (!res.duration || res.duration < 1) {
          this.showEmptyAudioMessage();
          clearExtraMessage();
          return;
        }
        options.file_length = res.duration > AUDIO_TOTAL_TIME ? AUDIO_TOTAL_TIME : res.duration;
      } else {
        fileUri = await upload(blob, `${uuidV4()}.${options.fileType}`);
      }
    } catch (error) {
      const MSG_TYPE = {
        audio: '语音',
      };
      console.error(error);
      this.addToast(`${MSG_TYPE[options.message_content_type] || '图片'}上传失败`, 2000);
      clearExtraMessage();
      return;
    }

    const {
      sysVersion: sys_version,
      os,
      studyEnv: study_env,
      browser,
      projectUrl: project_url,
    } = sys;
    const {
      lectureId: lecture_id,
      messageSource: message_source,
      courseId: courser_id,
      packageId: clazz_id,
    } = data;
    const { transformMessage } = options;
    delete options.transformMessage;
    const reqBody = {
      browser,
      sys_version,
      os,
      study_env,
      project_url,
      clazz_id,
      courser_id,
      message_source,
      lecture_id,
      message: transformMessage ? transformMessage(fileUri) : fileUri,
      msg_source: message_source,
      platform,
      ...options,
    };


    sendMessage(reqBody)
      .then((res) => {
        $updateMessage({
          online: res.online,
          message: res,
        });
        if (cb) {
          cb.apply(null, ['success', blob, $updateMessage]);
        }
        methods.emit('sendText', 'success', res, $updateMessage);
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        const errorMsg = this.generateErrorMsg(reqBody);
        this.addToast('发送消息失败，请重试', 2000);
        $updateMessage(errorMsg);
        sendLog(reqBody);
        console.error(`发送消息失败：${e}`);
        if (cb) {
          cb.apply(null, ['error', blob, $updateMessage]);
        }
      }).finally(() => {
        clearExtraMessage();
      });
  };

  /**
   * 发送语音消息
   * @param {number} duration
   * @param {Blob=} blob
   */
  $sendAudio = async (duration, blob) => {
    this.sendBlob(blob, {
      fileType: 'wav',
      file_length: duration,
      message_content_type: 'audio',
      cb: this.props.methods.sendAudio,
    }).then();
    this.setState({
      recording: false,
    });
  };

  /**
   * 发送文本消息
   * @param {{}} messageParams 消息参数(外部调用时方便传递参数用)
   */
  sendTextMessage = debounce((messageParams = {}) => {
    // noinspection JSDeprecatedSymbols
    /** @type HTMLElement */
    const node = this.refs.editNode;
    const { methods, data, $updateMessage } = this.props;
    const cb = methods && methods.sendText;
    const { customEnd = '' } = data || {};
    const content = node.innerText;
    const contentHtml = node.innerHTML;
    const isCheckIncludeTag = this.checkIncludeTag(contentHtml);
    const formData = {
      ...postMessageData(data, { message: !customEnd ? content : `<span>${content}${customEnd}</span>` }),
      ...messageParams,
    };
    const messageContent = content;
    if (isCheckIncludeTag) {
      // 处理复制的图片(不可以发送复制的图片)
      this.addToast('不可以发送包含特殊字符的消息哦', 2000);
    } else if (!messageContent.trim()) {
      cb && cb.apply(null, ['error', messageContent, $updateMessage]);
    } else {
      sendMessage(formData)
        .then((res) => {
          $updateMessage({
            online: res.online,
            message: res,
          });
          cb && cb.apply(null, ['success', res, $updateMessage]);
          methods.emit('sendText', 'success', res, $updateMessage);
        })
        .catch((e) => {
          sendLog(formData);
          // eslint-disable-next-line no-console
          console.error(`发送消息失败：${e}`, e);
          this.addToast('发送消息失败，请重试', 2000);
          const errorMsg = this.generateErrorMsg(formData);
          $updateMessage(errorMsg);
          cb && cb.apply(null, ['error', { content }, $updateMessage]);
        });

      node.innerHTML = '';
      this.setState({
        editing: false,
        hasTextMessage: false,
        selecting: false,
      });
    }
  }, DEBOUNCE_TIME);

  addToast = (content, duration) => {
    const toastDiv = document.createElement('div');
    const div = document.querySelector('.dl-wrapper');
    if (!div) return;
    div.appendChild(toastDiv);
    ReactDOM.render(<Toast content={content} />, toastDiv);

    this.timer = setTimeout(() => {
      ReactDOM.unmountComponentAtNode(toastDiv);
      div.removeChild(toastDiv);
    }, duration);
  };

  // 检测文本框是否含有 <img 标签
  checkIncludeTag = (content) => content && /<img[^>]+>/.test(content);

  // 打开或者关闭emoj
  // noinspection SpellCheckingInspection
  openOrCloseEmoj = () => {
    this.setState((prev) => ({
      selecting: !prev.selecting,
      editing: true,
    }));
  };

  $selectEmoj = (emoj) => {
    // noinspection JSDeprecatedSymbols
    const node = this.refs.editNode;
    this.setState({
      editing: true,
    });
    node.innerHTML += emoj;
    this.openOrCloseEmoj();
  };

  // noinspection JSUnusedGlobalSymbols
  $cancelAudio = () => {
    this.setState({
      recording: false,
    });
  };

  enterKeyDown = (e) => {
    if (e.keyCode === ENTER_KEYCODE) {
      this.sendTextMessage();
      e.target.blur();
      this.setState({
        hasTextMessage: false,
      });
    }
  }

  enterKeyUp = () => {
    // noinspection JSDeprecatedSymbols
    const {
      /** @type {HTMLElement} */
      editNode,
    } = this.refs;
    if (editNode) {
      this.setState({
        hasTextMessage: !!editNode.innerText,
      });
    }
  };

  showEmptyAudioMessage = () => {
    const containerBlock = document.createElement('div');
    ReactDOM.render(<Toast content="说话时间太短" />, containerBlock);
    document.body.appendChild(containerBlock);

    this.timer = setTimeout(() => {
      ReactDOM.unmountComponentAtNode(containerBlock);
      document.body.removeChild(containerBlock);
    }, 3000);
  };

  handleAudioButtonClick = () => {
    if (this.audioIsPrimary) {
      this.setState({
        audioIntermediateVisible: true,
      });
      return;
    }
    this.triggerStartRecording();
  };

  handleKeyboardButtonClick = () => {
    this.setState({
      audioIntermediateVisible: false,
    });
  };

  triggerStartRecording = () => {
    this.setState({
      audioVisible: true,
    });
    this.initRecord().then(() => {
      bus.emit(START_SEND_AUDIO);
    });
  };

  stopRecording = () => {
    this.record && this.record.stop();
    this.setState({
      loudness: 0,
      audioVisible: false,
    });
  }

  handleRecordSendClick = debounce(() => {
    this.audioCancelStatus = false;
    this.delayShowAudioEmptyInfo();
    this.stopRecording();
  }, DEBOUNCE_TIME);

  handleRecordCancelClick = () => {
    this.audioCancelStatus = true;
    this.stopRecording();
    if (this.record) {
      if (this.record.upload) {
        this.record.upload().then();
      }
      this.record = null;
    }
  };

  handleAudioGuideModalClose = () => {
    this.setState({
      audioGuideModalVisible: false,
    });
  };

  /**
   * @param {number} duration
   * @param {Blob=} blob
   */
  handleAudioFinish = (duration, blob) => {
    if (this.audioCancelStatus || !this.record) {
      return;
    }
    this.delayShowAudioEmptyInfo.cancel();

    if (!this.record.upload && (duration < 1 || !blob.size)) {
      this.showEmptyAudioMessage();
      return;
    }

    this.$sendAudio(
      duration > AUDIO_TOTAL_TIME ? AUDIO_TOTAL_TIME : duration,
      blob
    ).then();
  };

  async initRecord() {
    try {
      this.record = await record({
        onSuccess: (blob, duration) => {
          this.handleAudioFinish(duration, blob);
        },
        onGetAuthSuccess: () => {
          this.setState({
            audioAuthSuccess: true,
          });
        },
        onGetAuthError: () => {
          this.setState({
            audioAuthFailed: true,
            audioGuideModalVisible: true,
          });
        },
        onLoudnessChange: (db) => {
          this.setState({
            loudness: db,
          });
        },
      });
    } catch (e) {
      console.error('开始录音时出错:', e);
      throw e;
    }
  }

  // 发送工程
  sendFile = debounce(() => {
    const { $updateMessage } = this.props;
    const { methods } = this.props;
    methods && methods.sendFile && methods.sendFile($updateMessage);
    methods.emit('sendFile');
  }, DEBOUNCE_TIME)

  // 发送本课问题
  sendQuestion = debounce(() => {
    const { data, $updateMessage, methods } = this.props;
    // 不能发送本课问题
    if (!(data && data.canSendQuestion)) return;
    const cb = methods && methods.sendQuestion;
    request({
      url: ApiUri.OBTAIN_PROBLEMS,
      method: 'post',
      data: { lectureOid: data && data.lectureId },
      headers: {
        token: getToken(),
        'x-csrf-token': data && data.csrf,
      },
    }).then(
      /**
       * @param {{ status: number, body: any }} res
       */
      (res) => {
        if (res.status === 200) {
          $updateMessage(res.body);
          cb && cb.apply(null, ['success', $updateMessage]);
        } else {
          cb && cb.apply(null, ['error', $updateMessage]);
        }
      }
    ).catch((err) => {
      console.error('获取本课问题error:', err);
    });
  }, DEBOUNCE_TIME);

  transformImgMessage = (url) => `<img src="${url}" alt="${url}" style="max-width: 100%" />`

  showCaptureEffect = () => {
    const containerBlock = document.createElement('div');
    containerBlock.setAttribute('class', 'capture-screen-effect');
    document.body.appendChild(containerBlock);
    if (this.captureAudioRef.current) {
      this.captureAudioRef.current.play();
    }
    setTimeout(() => {
      document.body.removeChild(containerBlock);
    }, 500);
  };

  // 截屏
  captureScreen = debounce(async () => {
    const { toggleDialog } = this.props;
    // 截屏时关闭IM聊天窗口；
    toggleDialog(false);
    this.setState({
      captureTip: '',
    });

    // electron Capture的时候 下次渲染可能还没好， IM聊天窗口还没隐藏就截图了， 设置个延时
    setTimeout(async () => {
      try {
        const scaleFactory = 2;
        const capturedBuffer = await this.capturePage(scaleFactory);
        const fileBlob = new Blob([capturedBuffer], { type: 'image/png' });
        this.sendBlob(fileBlob, {
          fileType: 'png',
          message_content_type: 'text',
          transformMessage: this.transformImgMessage,
          cb: this.props.methods.sendCapture,
        }).then();
        this.showCaptureEffect();
      } catch (e) {
        console.error(e);
      } finally {
        toggleDialog(true);
        this.setState({
          captureTip: '发送截图',
        });
      }
    }, 300);
  }, DEBOUNCE_TIME)

  render() {
    const { data } = this.props;
    const { exts = [] } = data || {};
    const {
      editing,
      recording,
      selecting,
      placeholder,
      audioVisible,
      audioAuthFailed,
      audioAuthSuccess,
      audioGuideModalVisible,
      loudness,
      hasTextMessage,
      captureTip,
      audioIntermediateVisible,
      browserCanSendAudio,
    } = this.state;
    const recordStatus = audioVisible && !audioAuthFailed;

    const shouldShowAudioInterMedia = browserCanSendAudio && audioIntermediateVisible;
    const audioIntermediateElementStyle = { display: shouldShowAudioInterMedia ? 'block' : 'none' };
    const nonAudioIntermediateElementStyle = { display: shouldShowAudioInterMedia ? 'none' : 'block' };

    return (
      <>
        <div className="sd-wrapper">
          <Emoj
            $selectEmoj={this.$selectEmoj}
            selecting={selecting}
          />
          <div className={recording ? 'hide' : ''}>
            <div className="sd-send-wrapper">
              {browserCanSendAudio && (
                <div
                  style={audioIntermediateElementStyle}
                  className="sd-trigger-start-recording-button-wrapper"
                >
                  <div onClick={this.triggerStartRecording} className="sd-trigger-start-recording-button">
                    <img
                      className="sd-trigger-start-recording-button-icon"
                      src={`${CDN_BASE_URL}/voice.svg`}
                      alt="语音"
                    />
                    <span>发送语音</span>
                  </div>
                </div>
              )}

              <section style={audioIntermediateElementStyle} className="sd-send-btns">
                <Tooltip
                  title="显示文字输入框"
                  position="bottomRight"
                  style={{ width: 128, transform: 'translate(-84%, -146%)' }}
                >
                  <img
                    src={`${CDN_BASE_URL}/keyboard.svg`}
                    alt="显示文字输入框"
                    onClick={this.handleKeyboardButtonClick}
                  />
                </Tooltip>
              </section>

              {browserCanSendAudio && (
                <section style={nonAudioIntermediateElementStyle} className="sd-send-btns">
                  <Tooltip title="发送语音">
                    <img
                      style={{ marginLeft: '0' }}
                      className="sd-audio-btn"
                      onClick={this.handleAudioButtonClick}
                      src={`${CDN_BASE_URL}/voice.svg`}
                      alt="语音"
                    />
                  </Tooltip>
                </section>
              )}

              <div
                style={nonAudioIntermediateElementStyle}
                className={editing ? 'sd-input editing' : 'sd-input'}
                contentEditable
                onKeyDown={this.enterKeyDown}
                onKeyUp={this.enterKeyUp}
                placeholder={placeholder}
                ref="editNode"
              />

              {
                hasTextMessage ? (
                  <>
                    <section className="sd-send-btns">
                      <Tooltip title="发送表情符号" style={{ width: 128 }}>
                        <img
                          src={`${CDN_BASE_URL}/emoji0${selecting ? 2 : 1}.svg`}
                          alt="emoji"
                          onClick={() => this.openOrCloseEmoj()}
                        />
                      </Tooltip>
                    </section>
                    <section className="sd-send-btns">
                      <Tooltip title="发送消息" position="bottomRight" style={{ transform: 'translate(-84%, -146%)' }}>
                        <img
                          src={`${CDN_BASE_URL}/send03.svg`}
                          alt="发送消息"
                          onClick={() => this.sendTextMessage()}
                        />
                      </Tooltip>
                    </section>
                  </>
                ) : (
                  <>
                    <section className="sd-send-btns">
                      <Tooltip title="本课常见问题" style={{ width: 128 }}>
                        <img
                          className={data && data.canSendQuestion ? '' : 'hide'}
                          src={`${CDN_BASE_URL}/question.svg`}
                          alt="本课常见问题"
                          onClick={this.sendQuestion}
                        />
                      </Tooltip>
                    </section>
                    <section className="sd-send-btns">
                      <Tooltip title="发送工程">
                        <img
                          className={data && data.isScratch && !data.hideSendFile ? '' : 'hide'}
                          src={`${CDN_BASE_URL}/file02.svg`}
                          alt="发送工程"
                          onClick={this.sendFile}
                        />
                      </Tooltip>
                    </section>
                    <section className="sd-send-btns">
                      <Tooltip
                        title={captureTip}
                        position="bottomRight"
                        style={{ transform: 'translate(-84%, -146%)' }}
                      >
                        <img
                          className={this.capturePage ? '' : 'hide'}
                          src={`${CDN_BASE_URL}/image04.svg`}
                          onClick={this.captureScreen}
                          alt="截图"
                        />
                      </Tooltip>
                      {exts.map(({ title, className, enable, icon, onClick }, index) => (
                        <Tooltip
                          key={index}
                          title={title}
                          position="bottomRight"
                          style={{ transform: 'translate(-84%, -146%)' }}
                        >
                          <img
                            className={enable ? className : 'hide'}
                            src={icon}
                            onClick={onClick}
                            alt={icon}
                          />
                        </Tooltip>))}
                    </section>
                  </>
                )
              }
            </div>
          </div>

          <RecordBox
            visible={recordStatus}
            heartbeat={audioAuthSuccess}
            totalTime={AUDIO_TOTAL_TIME}
            onSend={this.handleRecordSendClick}
            onCancel={this.handleRecordCancelClick}
            loudness={loudness}
          />

          <AudioGuideModal
            visible={audioGuideModalVisible}
            onClose={this.handleAudioGuideModalClose}
          />

          <audio src={`${CDN_BASE_URL}/capture.wav`} ref={this.captureAudioRef} />
        </div>
      </>
    );
  }
}

Send.propTypes = {
  data: PropTypes.shape({
    isMobile: PropTypes.bool,
    courseId: PropTypes.string,
    lectureId: PropTypes.string,
    hideSendFile: PropTypes.func,
    packageId: PropTypes.string,
    csrf: PropTypes.string,
    canSendQuestion: PropTypes.bool,
    isScratch: PropTypes.bool,
  }),
  methods: PropTypes.shape({
    initRecord: PropTypes.func,
    sendAudio: PropTypes.func,
    sendCapture: PropTypes.func,
    sendFile: PropTypes.func,
    sendQuestion: PropTypes.func,
    sendText: PropTypes.func,
    emit: PropTypes.func,
  }),
  $updateMessage: PropTypes.func,
  toggleDialog: PropTypes.func,
  showExtraMessage: PropTypes.func,
  clearExtraMessage: PropTypes.func,
};

export default Send;
